<template>
  <div
    v-if="venues.length"
    :class="{
      'sm:truncate-none block max-w-[300px] truncate sm:max-w-none sm:whitespace-normal': isShort
    }"
    class="w-fit text-pretty text-left !text-sm"
    v-bind="$attrs"
  >
    {{ venues }}
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { toPlural } from '@/6_shared/lib'
import type { Event } from '../../model'

type PropType = {
  value: Event
  isShort?: boolean
}

const props = withDefaults(defineProps<PropType>(), {
  isShort: false
})

const venues = computed(() => {
  const venues = props.value.venueNames

  if (venues.length === 1) return venues[0]

  return toPlural(venues.length, 'площадка', 'площадки', 'площадок')
})
</script>
